export default "__VITE_ASSET__BIoq6kqn__"